// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__38coE","filesListContainer":"PosDisputesFiles_filesListContainer__2uUja","filesButton":"PosDisputesFiles_filesButton__3jWQL"};